import { EntitledToView } from '@news-mono/web-common'
import React from 'react'
import {
    StyledPromoImg,
    StyledSummerOfCricketLink,
    StyledSummerOfCricketPromoCard,
} from './SummerOfCricketPromoCard.styled'

export const EntitledView = () => {
    const promo = require('./assets/2025-Summer-of-Cricket-Logged-In-308x280.png')

    return (
        <StyledSummerOfCricketPromoCard>
            <StyledSummerOfCricketLink to="https://thewest.com.au/ashesmagread">
                <StyledPromoImg
                    src={promo}
                    alt="Read the Digital Cricket Magazine"
                />
            </StyledSummerOfCricketLink>
        </StyledSummerOfCricketPromoCard>
    )
}
export const OpportunityView: React.FC = () => {
    const promo = require('./assets/2025-Summer-of-Cricket-Logged-Out-308x280.png')

    return (
        <StyledSummerOfCricketPromoCard>
            <StyledSummerOfCricketLink to="https://subscriber.thewest.com.au/offercheck/thewest?redirect=true&offerCode=CRKT25_1">
                <StyledPromoImg
                    src={promo}
                    alt="Get access to the digital mag now - Find out how"
                />
            </StyledSummerOfCricketLink>
        </StyledSummerOfCricketPromoCard>
    )
}

export const SummerOfCricketPromoCard: React.FC = () => {
    return (
        <EntitledToView
            requiredAccess={{ level: 'subscriber' }}
            entitled={() => {
                return <EntitledView />
            }}
            notEntitled={() => {
                return <OpportunityView />
            }}
        />
    )
}
